'use strict';

exports.__esModule = true;
exports.page = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _pageActions = require('../actions/page-actions');

var _practiceTransformers = require('../transformers/practice-transformers');

var _specialistTransformers = require('../transformers/specialist-transformers');

var _constants = require('../utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  selectedLayout: {
    name: 'page',
    id: 'page'
  },
  selectedTheme: {
    name: 'Light',
    id: 'light'
  },
  customizations: {
    reviewItemFrame: true,
    wrapperFrame: true,
    minReviewRating: 0
  },
  selectedMultipleProfiles: []
};

var page = exports.page = function page(state, action) {
  switch (action.type) {
    case _pageActions.GET_PRACTICE_AUTOCOMPLETE + '_RECEIVED':
      return (0, _assign2.default)({}, state, {
        fetchedPractices: typeof action.response === 'string' ? [{ name: 'No Match found' }] : (action.response || []).map(_practiceTransformers.practiceAutocompleteTransformer)
      });
    case _pageActions.GET_SPECIALIST_AUTOCOMPLETE + '_RECEIVED':

      return (0, _assign2.default)({}, state, {
        fetchedSpecialists: typeof action.response === 'string' ? [{ name: 'No Match found' }] : (action.response || []).map(_specialistTransformers.specialistAutocompleteTransformer)
      });
    case _pageActions.ON_PRACTICE_SELECTED:
      return (0, _assign2.default)({}, state, { selectedPractice: action.practice });
    case _pageActions.ON_PROFILE_TYPE_SELECTED:
      return (0, _assign2.default)({}, state, {
        selectedProfileType: action.profileType,
        selectedProfile: null,
        fetchedPractices: null,
        fetchedSpecialists: null,
        selectedDefaultTab: null
      });
    case _pageActions.ON_PROFILE_SELECTED:
      var shouldAddToMultipleProfiles = state.selectedMultipleProfiles.length === 0 && state.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE;

      return (0, _assign2.default)({}, state, {
        selectedProfile: action.profile,
        selectedMultipleProfiles: shouldAddToMultipleProfiles ? [action.profile] : [].concat(state.selectedMultipleProfiles)
      });
    case _pageActions.ON_DEFAULT_TAB_SELECTED:
      return (0, _assign2.default)({}, state, {
        selectedDefaultTab: action.defaultTab
      });
    case _pageActions.ON_LAYOUT_SELECTED:
      return (0, _assign2.default)({}, state, {
        selectedLayout: action.layout
      });
    case _pageActions.ON_BACKGROUND_SELECTED:
      return (0, _assign2.default)({}, state, {
        selectedBackground: action.background
      });
    case _pageActions.DISABLE_BANNER:
      return (0, _extends3.default)({}, state, {
        disableBanner: action.disableBanner
      });
    case _pageActions.DISABLE_PROFILE_IMAGE:
      return (0, _extends3.default)({}, state, {
        disableProfileImage: action.disableProfileImage
      });
    case _pageActions.DISABLE_TABS:
      return (0, _extends3.default)({}, state, {
        disableTabs: action.disableTabs
      });
    case _pageActions.ON_THEME_SELECTED:
      return (0, _extends3.default)({}, state, { selectedTheme: action.theme });
    case _pageActions.ON_HREF_LINK_CHANGED:
      return (0, _extends3.default)({}, state, { hrefLink: action.hrefLink });
    case _pageActions.ON_CUSTOMIZATION_PROPS_CHANGE:
    case _pageActions.ON_REVIEW_ITEM_COLOR_PICKER_TOGGLE:
      return (0, _extends3.default)({}, state, action.payload);
    case _pageActions.ON_WF_PEER_RECOMMENDATION_TABS_CHANGED:
      return (0, _extends3.default)({}, state, { wfPeerRecommendationTabs: action.tabs });
    case _pageActions.ON_WF_PEER_RECOMMENDATION_ACTIVE_TAB_CHANGED:
      return (0, _extends3.default)({}, state, { wfPeerRecommendationActiveTab: action.tab });
    case _pageActions.ON_MULTIPLE_PROFILE_SELECTED:
      var shouldUpdateSingleProfile = !state.selectedProfileType && !state.selectedProfile || state.selectedProfileType && state.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE && !state.selectedProfile;

      if (state.selectedMultipleProfiles.findIndex(function (item) {
        return item.id === action.profile.id;
      }) === -1) {
        return (0, _extends3.default)({}, state, {
          selectedMultipleProfiles: [].concat(state.selectedMultipleProfiles, [action.profile]),
          selectedProfileType: shouldUpdateSingleProfile ? {
            id: _constants.PRACTICE_PROFILE_TYPE,
            name: 'practice'
          } : state.selectedProfileType,
          selectedProfile: shouldUpdateSingleProfile ? action.profile : state.selectedProfile
        });
      } else {
        return state;
      }
    case _pageActions.ON_MULTIPLE_PROFILE_REMOVED:
      var shouldRemoveSingleProfile = state.selectedProfile.id === action.profileId;

      return (0, _assign2.default)({}, state, {
        selectedMultipleProfiles: shouldRemoveSingleProfile ? [] : state.selectedMultipleProfiles.filter(function (profile) {
          return profile.id !== action.profileId;
        }),
        selectedProfileType: shouldRemoveSingleProfile ? null : state.selectedProfileType,
        selectedProfile: shouldRemoveSingleProfile ? null : state.selectedProfile
      });
    default:
      return state || INITIAL_STATE;
  }
};